<div
  id="pcoded"
  class="pcoded"
  [ngClass]="animateSidebar"
  [attr.nav-type]="navType"
  [attr.theme-layout]="themeLayout"
  [attr.horizontal-placement]="verticalPlacement"
  [attr.horizontal-layout]="verticalLayout"
  [attr.pcoded-device-type]="pcodedDeviceType"
  [attr.vertical-nav-type]="verticalNavType"
  [attr.vertical-effect]="verticalEffect"
  [attr.hnavigation-view]="vnavigationView"
  [attr.fream-type]="freamType"
  [attr.layout-type]="layoutType"
  (window:resize)="onResize($event)"
>
  <div class="pcoded-container navbar-wrapper">
    <nav
      class="navbar header-navbar pcoded-header"
      [attr.header-theme]="headerTheme"
      [attr.pcoded-header-position]="pcodedHeaderPosition"
    >
      <div class="navbar-wrapper">
        <div class="navbar-logo">
          <div [hidden]="hideNavMenu">
            <a class="mobile-menu ripple light nav-list" id="mobile-collapse" href="javascript:">
              <em class="feather" [ngClass]="toggleIcon"></em>
            </a>
          </div>
          <a class="logo light">
            <img class="client-logo" [attr.src]="clientLogo ? logoSafeUrl : logoUrl" alt=""/>
          </a>
          <a (click)="resetHomeTab()" [routerLink]="['/home']" class="logo ripple light cursor-pointer">
            <img class="logbook-logo" [src]="branding.headerLogo" [alt]="branding.wordmark"/>
          </a>
          <div class="text-white d-inline-block m-0 light nav-list">
            {{ clock | momentDate: timeFormat$ }}
          </div>
          <div
            [hidden]="pcodedDeviceType !== deviceType.desktop"
            class="header-notification ripple light navbar-margins"
            appToggleFullScreen
          >
            <a href="javascript:">
              <em class="fas fa-expand-arrows-alt full-screen"></em>
            </a>
          </div>
          <em class="fas fa-sync-alt refresh cursor-pointer" (click)="reloadCurrentPage()"></em>
        </div>
        <div class="navbar-container container-fluid display-inline">
          <ul class="nav-left">
            <li class="ripple light">
              <div class="sidebar_toggle">
                <a href="javascript:"><em class="icon-menu"></em></a>
              </div>
            </li>
          </ul>
          <ul [@mobileHeaderNavRight]="navRight" [ngClass]="navRight" class="nav-right">
            <scw-nav-items
              [(navBarDropdowns)]="navBarDropdowns"
              [(profileDropdown)]="profileDropdown"
              [(profileDropdownClass)]="profileDropdownClass"
            ></scw-nav-items>
            <li
              *ngIf="userName"
              class="user-profile header-notification ripple light"
              (click)="toggleProfileDropdown()"
              (clickOutside)="collapseOpenDropdown('profile')"
            >
              <a class="mobile-nowrap" href="javascript:">
                <em class="fas fa-user"></em>
                <em class="dropdown-icon feather icon-chevron-down"></em>
              </a>
              <ul
                [@notificationBottom]="profileDropdown"
                class="router-dropdown show-notification profile-notification"
                [ngClass]="profileDropdownClass"
              >
                <li class="ripple">
                  <a (click)="showPinChangeModal()">
                    <em class="fas fa-cog"></em> {{ 'general.changePin' | translate }}
                  </a>
                </li>
                <li class="ripple">
                  <a (click)="showForgotPinModal()">
                    <em class="fas fa-question-circle"></em> {{ 'general.forgotPin' | translate }}
                  </a>
                </li>
                <li class="ripple">
                  <a (click)="goLink({ external: false, state: '/knowledge-base' })">
                    <em class="fas fa-question"></em> {{ 'general.knowledgeBase' | translate }}
                  </a>
                </li>
                <li *ngIf="hasSubmitTicketRight" class="ripple">
                  <a [href]="submitATicketUrl" target="_blank">
                    <em class="fas fa-ticket-alt"></em> {{ 'general.submitATicket' | translate }}
                  </a>
                </li>
                <li class="ripple">
                  <a (click)="userLogout()">
                    <em class="fas fa-sign-out-alt"></em> {{ 'general.logout' | translate }}
                  </a>
                </li>
                <li class="login-user">
                  <span><strong>{{ 'home.main.user.loginUser' | translate }}</strong> {{ userName }}</span>
                </li>
                <li class="version">
                  <span><strong>{{ 'general.version' | translate }}:</strong> {{ appVersion }}</span>
                </li>
              </ul>
            </li>
            <li *ngIf="accessToOee">
              <ul>
                <li class="ripple">
                  <a href="javascript:void(0);" (click)="onClickGoToOee(oeeUrl)">
                    <svg
                      width="54"
                      height="24"
                      viewBox="0 0 54 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      style="margin-top: -5px; margin-left: -5px"
                    >
                      <rect x="0.5" y="0.5" width="51" height="23" rx="3.5" fill="#EEF1F7" stroke="#AEB0B8"/>
                      <path
                        d="M9.16663 10.9948V10.6302C9.16663 10.3282 9.41147 10.0834 9.7135 10.0834H17.9166V8.98962C17.9166 8.50274 18.5068 8.2595 18.8502 8.60291L20.6731 10.4258C20.8867 10.6394 20.8867 10.9857 20.6731 11.1992L18.8502 13.0221C18.5081 13.3642 17.9166 13.1244 17.9166 12.6355V11.5417H9.7135C9.41147 11.5417 9.16663 11.2969 9.16663 10.9948ZM20.2864 14.4584H12.0833V13.3646C12.0833 12.8789 11.494 12.6336 11.1497 12.9779L9.32679 14.8008C9.11324 15.0144 9.11324 15.3607 9.32679 15.5742L11.1497 17.3971C11.4921 17.7396 12.0833 17.4989 12.0833 17.0105V15.9167H20.2864C20.5885 15.9167 20.8333 15.6719 20.8333 15.3698V15.0052C20.8333 14.7032 20.5885 14.4584 20.2864 14.4584Z"
                        fill="#656671"
                      />
                    </svg>
                    <img
                      class="switch-df-logo"
                      height="20"
                      src="data:image/png;base64,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"
                    />
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="pcoded-main-container min-vh-100" [style.margin-top]="headerFixedMargin">
      <div class="pcoded-wrapper">
        <div class="pcoded-content">
          <page-header [pageHeader]="pageHeader"></page-header>
          <div [class.pcoded-inner-content]="!pageHeader?.isTabPage">
            <!-- Main-body start -->
            <div class="main-body">
              <div class="page-wrapper">
                <router-outlet>
                  <title></title>
                  <app-spinner></app-spinner>
                </router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<scw-pin-change></scw-pin-change>
<scw-forgot-pin></scw-forgot-pin>
